import { ActionMessageId, ActionType, AttachmentFullViewState } from 'owa-attachment-full-data';
import { orchestrator } from 'satcheljs';
import setOngoingActionAndActionMessage from '../actions/setOngoingActionAndActionMessage';
import addCalendarEventsAttachment from '../actions/addCalendarEventsAttachment';
import { stopFakeProgressIndicator } from '../utils/FakeProgressIndicator';
import addCompletedAction from '../actions/addCompletedAction';
import ImportCalendarEventResponseMessage from 'owa-service/lib/contract/ImportCalendarEventResponseMessage';
import addToCalendarAttachmentService from 'owa-preview-ics/lib/services/addToCalendarAttachmentService';
import { ClientAttachmentId } from 'owa-client-ids';
import AddToCalendarSource from '../schema/AddToCalendarSource';

// exporting it for the testing purpose
export default orchestrator(addCalendarEventsAttachment, async actionMessage => {
    addToCalendarPreProcess(actionMessage.attachment);

    const response: ImportCalendarEventResponseMessage = await addToCalendarAttachmentService(
        actionMessage.attachment.attachmentId.Id,
        null,
        null
    );
    const eventSucessState =
        response && response.ResponseClass === 'Success'
            ? ActionMessageId.ImportToCalendarCompletedWithIcon
            : ActionMessageId.ImportToCalendarFailedWithIcon;

    addToCalendarPostProcess(
        actionMessage.attachment.attachmentId,
        eventSucessState,
        actionMessage.attachment,
        ActionType.None,
        ActionType.AddToCalendar
    );
});

// Explicitely exporitng AddToCalendarSource as this enum, which is passed from subscribed action, is private to this file
export { AddToCalendarSource };

function addToCalendarPreProcess(attachment: AttachmentFullViewState) {
    setOngoingActionAndActionMessage(
        attachment,
        ActionType.AddToCalendar,
        ActionMessageId.ImportToCalendarInProgress
    );
}

function addToCalendarPostProcess(
    attachmentId: ClientAttachmentId,
    eventSucessState: ActionMessageId,
    attachment: AttachmentFullViewState,
    onGoingActionType: ActionType,
    completedActionType: ActionType
) {
    stopFakeProgressIndicator(attachmentId, true);
    addCompletedAction(attachment, completedActionType);
    setOngoingActionAndActionMessage(attachment, onGoingActionType, eventSucessState);
}
